import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Confirmation } from '@models/*';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {

    private confirmationSubject = new Subject<Confirmation<any>>();

    public sendConfirmation(operation: Confirmation<any>): void {
        this.confirmationSubject.next(operation);
    }

    get stream(): Observable<Confirmation<any>> {
        return this.confirmationSubject.asObservable().pipe(
            shareReplay(1)
        );
    }
}
